import script from "./ViewVoidedWarrantsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewVoidedWarrantsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewVoidedWarrantsPage.vue?vue&type=style&index=0&id=26d5a195&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d5a195"]])

export default __exports__